import APIUtils from '@spothero/utils/api';
import ObjectUtils from '@spothero/utils/object';
import ErrorUtils from 'utils/error-utils';
import Config from 'config';
import SpotUtils from 'utils/spot';
import {formatDistance} from '../search-v2/utils';

export const getFacilityDetail = (eventPackageId, facilityId, params) => {
    return APIUtils.get(
        `facilities/${facilityId}/rates/event-packages/${eventPackageId}/`,
        {
            include: Config.facilityIncludes,
            ...params,
        }
    )
        .then(response => {
            try {
                const unformattedHoursOfOperation =
                    response.data.data.facility.hours_of_operation;
                const facilityData = ObjectUtils.camelizeKeys(
                    response.data.data
                );

                const {
                    eventPackage,
                    bulkEventRates,
                    facility,
                    currencyType,
                    ratingInfo: {numberOfRatings: count, starRating: average},
                    operatorNotes,
                    spotNotes,
                } = facilityData;
                const {eventCount} = eventPackage;
                // differences between spot detail and search response
                // images, event package data, total price, currency symbol and type
                const {
                    title,
                    distance,
                    latitude,
                    longitude,
                    images,
                    amenitiesFull,
                    gettingHere,
                    redemptionInstructions,
                    restrictions,
                    vehicleRestrictionDescription,
                    operatorId,
                    city,
                    state,
                    cancellationAllowed,
                } = facility;

                // calculate total price
                const totalPrice = bulkEventRates.reduce(
                    (accmPrice, eventRate) => {
                        return accmPrice + eventRate.displayPrice;
                    },
                    0
                );

                const transformedResult = {
                    isV2: true,
                    spotId: `${facilityId}`,
                    title,
                    selectedRate: {
                        fullUrl: `/checkout/${facilityId}/event-packages/${eventPackageId}/`,
                        advertisedPrice: {
                            currencyCode: currencyType.toUpperCase(),
                            value: totalPrice / eventCount,
                        },
                        totalPrice: {
                            currencyCode: currencyType.toUpperCase(),
                            value: totalPrice,
                        },
                        amenities:
                            amenitiesFull?.map(amenity => ({
                                type: amenity.slug,
                                displayName: amenity.name,
                            })) || [],
                    },
                    rating: {
                        average,
                        count,
                    },
                    images: images.map(image => ({
                        id: image.id,
                        urlTemplate: image.urlTemplate,
                        url: '',
                        altText: `Photo of ${title}`,
                    })),
                    addresses: [
                        {
                            latitude,
                            longitude,
                            // dummy info
                            id: '',
                            city: '',
                            country: '',
                            postalCode: '',
                            state: '',
                            streetAddress: '',
                            timeZone: '',
                        },
                    ],
                    availability: {
                        available: true,
                        unavailableReasons: [],
                    },
                    distance: formatDistance(distance),
                    facilityType: 'unknown',
                    eventPackage: {
                        ...eventPackage,
                        events: eventPackage.events.map((event, index) => ({
                            ...event,
                            price: {
                                value: bulkEventRates[index].price,
                                priceBreakdown:
                                    bulkEventRates[index].priceBreakdown.items,
                                currencyCode: currencyType,
                            },
                        })),
                    },
                    vehicleRestrictionDescription,
                    facilityRestrictions: restrictions,
                    // we leave access hours formatted according to v1 data structure
                    // because the AccessHours component that displays this data
                    // is tightly coupled to it
                    accessHoursFormattedV1: SpotUtils.formatAccessHours(
                        unformattedHoursOfOperation
                    ),
                    navigationTip: gettingHere,
                    redemptionInstructions,
                    operatorNotes,
                    adminNotes: spotNotes,
                    operatorId,
                    city,
                    state,
                    cancellationAllowed,
                };

                return transformedResult;
            } catch (error) {
                return Promise.reject(new Error('Response shape unexpected.'));
            }
        })
        .catch(error => {
            ErrorUtils.sendSentryError(error);

            return Promise.reject(ErrorUtils.formatError(error));
        });
};
